import { render, staticRenderFns } from "./Cursos.vue?vue&type=template&id=2910429a&scoped=true"
import script from "./Cursos.vue?vue&type=script&lang=js"
export * from "./Cursos.vue?vue&type=script&lang=js"
import style0 from "./Cursos.vue?vue&type=style&index=0&id=2910429a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910429a",
  null
  
)

export default component.exports